import channelService from '@/api/channelService'
import debounce from '@/utils/debounce'
import templatesService from '@/api/templatesService'
import { CHANNEL_PRODUCT_TYPES } from '@/utils/campaignOptions'

const DEBOUNCE_TIME = 500

export default {
  name: 'TemplateForm',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      template: {
        name: undefined,
        target: undefined,
        products: []
      },
      productType: CHANNEL_PRODUCT_TYPES.REDIRECT.value,
      productTypeOptions: Object.values(CHANNEL_PRODUCT_TYPES),
      productOptions: [],
      targetOptions: []
    }
  },
  async mounted () {
    this.$emit('selectTab', { id: 'templates' })
    if (this.$route.params.templateid) {
      this.template = await templatesService.getTemplate({ id: this.$route.params.templateid })
    }

    this._targetSearch = debounce(this.targetSearch, DEBOUNCE_TIME)
    this._productSearch = debounce(this.productSearch, DEBOUNCE_TIME)

    this.targetSearch('')
    this.productSearch('')
  },
  computed: {
    formValid () {
      return this.template.name && this.template.target && this.template.products.length
    },
    isServiceFilter () {
      return this.productType === CHANNEL_PRODUCT_TYPES.DIRECT.value
    },
    productTypeLabel () {
      const type = CHANNEL_PRODUCT_TYPES[this.productType]
      return type && type.label
    }
  },
  methods: {
    closeModal () {
      this.$router.push('/administration')
    },
    slowTargetSearch (query) { this._targetSearch(query) },
    slowProductSearch (query) { this._productSearch(query) },
    targetSearch (query) {
      channelService.getSummary('targets', query).then(data => {
        this.targetOptions = data
      })
    },
    productSearch (query) {
      channelService.getSummary('products', query, { is_service: this.isServiceFilter }).then(data => {
        this.productOptions = data
      })
    },
    onSelectTarget (value) {
      this.$refs.targetSelector.close()
      this.$set(this.template, 'target', value)
    },
    onProductSelected (product) {
      if (this.productIsSelected(product)) {
        this.template.products = this.template.products.filter(p => p.id !== product.id)
      } else {
        this.template.products.push(product)
      }
    },
    productIsSelected (product) {
      return this.template.products.some(p => p.id === product.id)
    },
    updateScrollbar () {
      window.setTimeout(() => {
        if (this.$refs.scrollbar) this.$refs.scrollbar.update()
      }, 250)
    },
    async save () {
      if (!this.formValid) { return }
      const body = {
        name: this.template.name,
        products: this.template.products.map(p => p.id),
        target: this.template.target.id
      }
      try {
        let template
        let action = 'add'
        if (this.template.id) {
          body.id = this.template.id
          action = 'update'
          await templatesService.editTemplate(body)
          template = this.template
        } else {
          template = await templatesService.createTemplate(body)
        }
        this.$router.push({ path: `/administration` })
        this.$emit(action, { type: 'templates', value: template })
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[template-form.js] Error saving new template', err)
      }
    },
    onDirectionChange () {
      this.productSearch('')
      this.$set(this.template, 'products', [])
    }
  }
}
